import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApModalService } from '../modals';
import { ApModalResult } from 'webcommon/core-ui/modals-ng1520';
import { ApFileUploadModalComponent } from './ap-file-upload-modal.component';

export const transcribeWavTxtParams: Readonly<Parameters<ApFileUploadModalService['openModal']>> = [
  'Transcribe Recording',
  'You have selected to transcribe a preexisting recording. Please select the WAV or txt file.',
  '.wav,.txt',
];

export const transcribeWavParams: Readonly<Parameters<ApFileUploadModalService['openModal']>> = [
  'Transcribe Recording',
  'You have selected to transcribe a preexisting recording. Please select the WAV file.',
  '.wav',
];

@Injectable({
  providedIn: 'root',
})
export class ApFileUploadModalService {
  constructor(
    private apModalService: ApModalService,
  ) {
  }

  openModal(
    title = '',
    message = '',
    allowedExtensions = '',
  ): Observable<ApModalResult<File>> {
    const initialState = {
      allowedExtensions,
      message,
      title,
    };
    const obs = this.apModalService.showComponentModal$(ApFileUploadModalComponent, {
      initialState,
    });
    return obs;
  }
}
